/** Matches server careers.scoutsecond.server.agencylogic.model.OrgDetailsAgencyDisplayStatus */
enum OrgDetailsAgencyDisplayStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export { OrgDetailsAgencyDisplayStatus };
